import React, { forwardRef, useImperativeHandle, useMemo, useState } from 'react'
import { dateFormatWithTime, formatOnlyTimeToSQL, HourMinuteFromOnlyTime, isBlank } from '../../../../commonClass/CommonValidation';
import CustomColumn from '../../../../../customControl/CustomColumn';
import { TimePicker } from 'antd';
import dayjs from 'dayjs';
import { areArraysEqualIgnoreOrder } from '../../../../commonClass/CommonFunctions';
import { ConfirmationModal } from '../../../../../customControl/ConfirmationModal';
import Switch from 'react-switch';

const ActivitySlotSection = forwardRef((
    {
        ActivityManagePricingId,
        defaultActivitySlotForm, ActivitySlotsForm, setActivitySlotsForm,
        isActivitySlotEdit, setIsActivitySlotEdit,
        IsScheduleActivity, setIsScheduleActivity,
        ActivityManageSlots, setActivityManageSlots,
        dropdownData, formErrors, setFormErrors, disabled, setEditDisabled
    },
    ref) => {
    const [activeInActive, setActiveInActive] = useState({ SeqNo: 0, value: false })
    const [modalShow, setModalShow] = useState(false);
    const convertOpertedDaysTableFormat = (collection) => {
        return [...collection]?.reduce((acc, curr) => {
            acc = [...acc, {
                SeqNo: curr?.SeqNo,
                isActive: curr?.isActive,
                StartTime: HourMinuteFromOnlyTime(curr?.StartTime),
                EndTime: HourMinuteFromOnlyTime(curr?.EndTime),
                OperatedDaysName: dropdownData?.weekDayList
                    ?.filter(({ value }) => curr?.OperatedDayId?.includes(value) && value !== 1)
                    ?.map(({ label }) => label?.slice(0, 3))
                    ?.join(", ")
            }]
            return acc;
        }, [])
    }


    const handleRadioChange = (value) => {
        setEditDisabled(false);
        setFormErrors(null);
        setIsScheduleActivity(value);
        if (!value) {
            setActivityManageSlots([]);
            setActivitySlotsForm(defaultActivitySlotForm);
        }
    }

    const handleOnChange = (name, value) => {
        setEditDisabled(false);
        setFormErrors(null);
        if (name === "OperatedDayId") {
            setActivitySlotsForm(prev => {
                const { OperatedDayId = [] } = prev;
                const isSelected = OperatedDayId?.includes(value);
                const isSelectAll = value === 1;

                let updatedDays;

                if (isSelectAll) {
                    // Toggle Select All
                    updatedDays = isSelected
                        ? []
                        : dropdownData?.weekDayList?.map(day => day?.value);
                } else {
                    if (isSelected) {
                        // Remove specific day + remove Select All if present
                        updatedDays = OperatedDayId?.filter(id => id !== value && id !== 1);
                    } else {
                        // Add specific day
                        updatedDays = [...OperatedDayId?.filter(id => id !== 1), value];
                    }
                }

                return {
                    ...prev,
                    OperatedDayId: updatedDays,
                };
            });
        }
        else {
            setActivitySlotsForm(prev => ({ ...prev, [name]: value }));
        }
    }

    const isSlotDuplicate = (collection, newSlot) => {
        const newSeqNo = newSlot?.SeqNo;
        const newStart = dateFormatWithTime(new Date(), newSlot?.StartTime);
        const newEnd = dateFormatWithTime(new Date(), newSlot?.EndTime);
        const newDays = newSlot?.OperatedDayId;

        return collection?.some((existingSlot) => {
            if (existingSlot?.SeqNo === newSeqNo) return false;

            const existingStart = dateFormatWithTime(new Date(), existingSlot?.StartTime);
            const existingEnd = dateFormatWithTime(new Date(), existingSlot?.EndTime);
            const existingDays = existingSlot?.OperatedDayId;

            return areArraysEqualIgnoreOrder(existingDays, newDays) &&
                existingStart === newStart &&
                existingEnd === newEnd
        })
    }

    const isSlotOverlapping = (collection, newSlot) => {
        const newSeqNo = newSlot?.SeqNo;
        const newStart = dateFormatWithTime(new Date(), newSlot?.StartTime);
        const newEnd = dateFormatWithTime(new Date(), newSlot?.EndTime);

        return collection?.some((existingSlot) => {
            if (existingSlot?.SeqNo === newSeqNo) return false;

            const hasCommonDay = existingSlot?.OperatedDayId?.some(
                (dayId) => newSlot?.OperatedDayId?.includes(dayId)
            );

            if (!hasCommonDay) return false;

            const existingStart = dateFormatWithTime(new Date(), existingSlot?.StartTime);
            const existingEnd = dateFormatWithTime(new Date(), existingSlot?.EndTime);

            return newStart <= existingEnd && newEnd >= existingStart;
        });
    };


    const validationOnAddEdit = () => {
        let status = true;
        let error = {}

        if (isBlank?.includes(ActivitySlotsForm?.StartTime)) {
            error.StartTime = "Cannot leave blank, input is mandatory.";
        }
        if (isBlank?.includes(ActivitySlotsForm?.EndTime)) {
            error.EndTime = "Cannot leave blank, input is mandatory.";
        }
        if (ActivitySlotsForm?.OperatedDayId?.length <= 0) {
            error.OperatedDayId = "Cannot leave blank, input is mandatory.";
        }
        if (dateFormatWithTime(new Date(), ActivitySlotsForm?.EndTime) <= dateFormatWithTime(new Date(), ActivitySlotsForm?.StartTime)) {
            error.EndTime = "The end time must be greater than the start time.";
        }

        const hasDuplicateSlot = isSlotDuplicate(ActivityManageSlots, ActivitySlotsForm);
        const hasOverlap = isSlotOverlapping(ActivityManageSlots, ActivitySlotsForm);

        if (hasDuplicateSlot) {
            error.DuplicateSlot = "Time slots is already exist";
        }
        if (!hasDuplicateSlot && hasOverlap) {
            error.OverlapSlot = "Time slots is overlapping";
        }

        setFormErrors(error);

        if (Object.keys(error)?.length > 0) {
            status = false;
            const id = Object.keys(error)?.[0];
            document.getElementById(id)?.focus();
        }
        return status;
    }



    const handleSlotAddUpdate = () => {
        if (validationOnAddEdit()) {
            if (isActivitySlotEdit) {
                const updateActivitySlotsCollection = ActivityManageSlots?.map((obj) => {
                    if (obj?.SeqNo === ActivitySlotsForm?.SeqNo) {
                        obj.SeqNo = ActivitySlotsForm?.SeqNo;
                        obj.StartTime = ActivitySlotsForm?.StartTime ? ActivitySlotsForm?.StartTime : null;
                        obj.EndTime = ActivitySlotsForm?.EndTime ? ActivitySlotsForm?.EndTime : null;
                        obj.OperatedDayId = ActivitySlotsForm?.OperatedDayId ? ActivitySlotsForm?.OperatedDayId : [];
                        obj.activityManageActivitySlotId = ActivitySlotsForm?.activityManageActivitySlotId
                    }
                    return obj;
                });
                setActivityManageSlots(updateActivitySlotsCollection);
            }
            else {
                setActivityManageSlots((prev) => ([...prev, { ...ActivitySlotsForm, SeqNo: ActivityManageSlots?.length + 1, isActive: true }]))
            }
            setEditDisabled(false);
            setActivitySlotsForm(defaultActivitySlotForm)
        }
        setIsActivitySlotEdit(false);
    }

    const handleSlotEdit = (SeqNo) => {
        setFormErrors(null);
        setIsActivitySlotEdit(true);
        const slot = ActivityManageSlots?.find((prev) => prev?.SeqNo === SeqNo);
        setActivitySlotsForm((prev) => ({
            ...prev,
            SeqNo: SeqNo,
            StartTime: slot?.StartTime ? slot?.StartTime : null,
            EndTime: slot?.EndTime ? slot?.EndTime : null,
            OperatedDayId: slot?.OperatedDayId ? slot?.OperatedDayId : [],
            activityManageActivitySlotId :slot?.activityManageActivitySlotId
        }))
    }

    const handleSlotRemove = (SeqNo) => {
        setEditDisabled(false);
        setFormErrors(null);
        setIsActivitySlotEdit(false);
        setActivitySlotsForm(defaultActivitySlotForm);
        setActivityManageSlots(ActivityManageSlots?.filter((prev) => prev?.SeqNo !== SeqNo)?.map((obj, index) => { obj.SeqNo = index + 1; return obj }));
    }


    const ValidateActivitySlotsForm = () => {
        let error = {};

        // if ([null]?.includes(BookingCutOffForm?.CutOffDays)) {
        //     error.CutOffDays = "Cannot leave blank, input is mandatory."
        // }
        // if (isBlank?.includes(BookingCutOffForm?.CutOffTime)) {
        //     error.CutOffTime = "Cannot leave blank, input is mandatory."
        // }

        return error;
    }

    // Expose the childFunction to the parent's ref
    useImperativeHandle(ref, () => ({
        canValidate: false,
        ValidateActivitySlotsForm: ValidateActivitySlotsForm
    }));

    const handleisActive = (val, seqNo) => {
        setEditDisabled(false)
        setActiveInActive({ SeqNo: seqNo, value: val })
        setModalShow(true);
    }

    const handleConfirmation = (e) => {
        if (e === true) {
            setActivityManageSlots((prev) => prev.map((slot) => {
                if (slot.SeqNo === activeInActive.SeqNo) {
                    slot = { ...slot, isActive: activeInActive.value }
                }
                return slot
            }))
        }
        setModalShow(false);
    }
    return (
        <>
            <div className="row">
                <CustomColumn colNum={4} classChildren="align-content-center" labelText='Schedule Activity' labelId='ScheduleActivity'>
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="form-check">
                                <input
                                    type="radio"
                                    id="scheduleactivityyes"
                                    className="form-check-input"
                                    name="scheduleactivity"
                                    value={1}
                                    checked={IsScheduleActivity}
                                    onChange={() => handleRadioChange(true)}
                                    disabled={disabled}
                                />
                                <label htmlFor="scheduleactivityyes" className="form-check-label"> Yes </label>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="form-check">
                                <input
                                    type="radio"
                                    id="scheduleactivityno"
                                    className="form-check-input"
                                    name="scheduleactivity"
                                    value={2}
                                    checked={!IsScheduleActivity}
                                    onChange={() => handleRadioChange(false)}
                                    disabled={disabled || (ActivityManagePricingId > 0 && IsScheduleActivity)}
                                />
                                <label htmlFor="scheduleactivityno" className="form-check-label"> No </label>
                            </div>
                        </div>
                    </div>
                </CustomColumn>

                <CustomColumn colNum={4} labelText='Start Time' labelId='StartTime' isRequired={IsScheduleActivity} >
                    <TimePicker
                        className='form-control defo_border'
                        format='HH:mm'
                        placeholder='HH:mm'
                        id='StartTime'
                        disabled={disabled || !IsScheduleActivity}
                        value={ActivitySlotsForm?.StartTime ? dayjs(dateFormatWithTime(new Date(), ActivitySlotsForm?.StartTime)) : null}
                        onChange={(e) => handleOnChange('StartTime', e?.$d ? formatOnlyTimeToSQL(e?.$d) : null)}
                    />
                    {formErrors?.StartTime && <div className="text-danger text-start fs_14">{formErrors?.StartTime}</div>}
                </CustomColumn>

                <CustomColumn colNum={4} labelText='End Time' labelId='EndTime' isRequired={IsScheduleActivity} >
                    <TimePicker
                        className='form-control defo_border'
                        format='HH:mm'
                        placeholder='HH:mm'
                        id='EndTime'
                        disabled={disabled || !IsScheduleActivity}
                        value={ActivitySlotsForm?.EndTime ? dayjs(dateFormatWithTime(new Date(), ActivitySlotsForm?.EndTime)) : null}
                        onChange={(e) => handleOnChange('EndTime', e?.$d ? formatOnlyTimeToSQL(e?.$d) : null)}
                    />
                    {formErrors?.EndTime && <div className="text-danger text-start fs_14">{formErrors?.EndTime}</div>}
                </CustomColumn>

                <CustomColumn colNum={10} colLabel={2} colMDLabel={4} colChildren={10} colMDChildren={8} classChildren="align-content-center" labelText='Operated Days' labelId='OperatedDays' isRequired={IsScheduleActivity}>
                    {dropdownData?.weekDayList && dropdownData?.weekDayList?.map((ele, index) => {
                        return (
                            <div className="form-check-inline" key={index}>
                                <input className="form-check-input"
                                    type="checkbox"
                                    id={ele?.label}
                                    value={ele?.value}
                                    onChange={(e) => handleOnChange('OperatedDayId', ele?.value)}
                                    checked={ActivitySlotsForm?.OperatedDayId?.includes(ele?.value)}
                                    disabled={disabled || !IsScheduleActivity} />
                                <label htmlFor={ele?.label} className="form-check-label ms-1">{ele?.label}</label>
                            </div>
                        )
                    })}
                    {formErrors?.OperatedDayId && <div className="text-danger text-start fs_14">{formErrors?.OperatedDayId}</div>}
                </CustomColumn>

                <div className="col-12 text-center my-4">
                    <button
                        type="button"
                        className='btn btn-primary'
                        onClick={() => handleSlotAddUpdate()}
                        disabled={disabled || !IsScheduleActivity}
                    >
                        {isActivitySlotEdit ? "Update" : "Add"}
                    </button>
                </div>

                {formErrors?.DuplicateSlot && <div className="my-2 text-danger text-center fs_14">{formErrors?.DuplicateSlot}</div>}
                {formErrors?.OverlapSlot && <div className="my-2 text-danger text-center fs_14">{formErrors?.OverlapSlot}</div>}

                <div className="form_border">
                    <table className="table table-hover mt-2" >
                        <thead>
                            <tr>
                                <th>Operated Days</th>
                                <th className=''>Start Time</th>
                                <th className=''>End Time</th>
                                <th className='text-center'>Edit</th>
                                <th className='text-center'>Remove</th>
                                <th className='text-center'>Active/InActive</th>
                            </tr>
                        </thead>
                        <tbody id="location-data">
                            {ActivityManageSlots?.length > 0 && convertOpertedDaysTableFormat(ActivityManageSlots)?.map((element, index) => {
                                return (
                                    <tr className="ReactTable" key={element?.SeqNo}>
                                        <td >{element?.OperatedDaysName}</td>
                                        <td className=''>{element?.StartTime}</td>
                                        <td className=''>{element?.EndTime}</td>
                                        <td className='text-center'>
                                            <button
                                                type="button"
                                                onClick={(e) => { handleSlotEdit(element?.SeqNo) }}
                                                className="btn btn-primary mx-1"
                                                disabled={disabled ? true : false}
                                            >
                                                Edit
                                            </button>
                                        </td>
                                        <td className='text-center'>
                                            <button
                                                type="button"
                                                onClick={(e) => { handleSlotRemove(element?.SeqNo) }}
                                                className="btn btn-primary mx-1"
                                                disabled={disabled ? true : false}
                                            >
                                                Remove
                                            </button>
                                        </td>
                                        <td className='text-center'>
                                            <Switch
                                                onChange={(val) => handleisActive(val, element?.SeqNo)}
                                                checked={element?.isActive}
                                                className="react-switch"
                                                disabled={disabled ? true : false}
                                            />
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>

            </div>
            <ConfirmationModal
                show={modalShow}
                onHide={() => setModalShow(false)}
                noconfirm={() => handleConfirmation(false)}
                yesconfirm={() => handleConfirmation(true)}
            />
        </>
    )
});

export default ActivitySlotSection